export const ONBOARDING_STEP_KEYS = [
  'knowledge_base',
  'shooting_setup',
  'decor_selection',
  'thumbnail_selection',
  'description_preferences',
  'network_connection',
  'editorial_planning',
  'cross_post',
  'team_introduction',
] as const;

export type OnboardingStepKey = (typeof ONBOARDING_STEP_KEYS)[number];

export const ONBOARDING_WEBHOOK_EVENTS = {
  STEP_STARTED: 'step_started',
  STEP_COMPLETED: 'step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ONBOARDING_SKIPPED: 'onboarding_skipped',
} as const;

export type OnboardingWebhookEvent = (typeof ONBOARDING_WEBHOOK_EVENTS)[keyof typeof ONBOARDING_WEBHOOK_EVENTS];
